// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Grid2x2 as RawGrid2x2 } from "lucide-react";
export const Grid2x2 = /* @__PURE__ */ createIcon(RawGrid2x2, "Grid2x2", 2);
